import { useTranslation } from 'react-i18next';
import { ConfirmationDialog } from 'app/components/composite/ConfirmationDialog';
import { useDispatch, useSelector } from 'app/lib/hooks';
import { doCancelAllQueries, selectIsCancelingAllQueries } from 'app/store/snowflakeQueries';
import { Defaults } from 'app/lib/constants';

export function CancelAllQueriesConfirmationDialog({
    onConfirm = Defaults.NOOP,
    onClose = Defaults.NOOP
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isCancelingAllQueries = useSelector(selectIsCancelingAllQueries);

    function handleCancelAll() {
        dispatch(doCancelAllQueries());
        onConfirm();
    }

    return (
        <ConfirmationDialog
            width={400}
            title={t('common:areYouSure')}
            confirm={t('components:CancelAllQueriesConfirmationDialog.confirm')}
            hint={t('components:CancelAllQueriesConfirmationDialog.hint')}
            isProcessing={isCancelingAllQueries}
            onSubmit={handleCancelAll}
            onClose={onClose}>
            <p>{t('components:CancelAllQueriesConfirmationDialog.warning')}</p>
        </ConfirmationDialog>
    );
}
